export * from './auth/auth.service';
export * from './classi.service';
export * from './questionari.service';
export * from './materie.service';
export * from './auth/classroom-auth.service';
export * from './moduliOrientativi.service';
export * from './contenuti.service';
export * from './studente.service';
export * from './competenze.service';
